module.exports = __webpack_public_path__ + "static/media/award_image_bg@2x.41d534f1.png";